import React, { useId } from 'react';
import { cx } from '../../utils/cx.js';

/** Accessible switch (role="switch") with an optional label and description on the left. */
const Toggle = ({ checked, onChange, label = null, description = null, disabled = false, className = '' }) => {
  const id = useId();
  const labelId = `${id}-label`;
  const descriptionId = `${id}-description`;

  const control = (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-labelledby={label ? labelId : undefined}
      aria-describedby={description ? descriptionId : undefined}
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      className={cx(
        'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer items-center rounded-full transition-colors',
        'outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-night-800',
        'disabled:cursor-not-allowed disabled:opacity-50',
        checked ? 'bg-brand-600' : 'bg-gray-300 dark:bg-gray-600',
      )}
    >
      <span className={cx('inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform', checked ? 'translate-x-[22px]' : 'translate-x-0.5')} />
    </button>
  );

  if (!label && !description) return control;

  return (
    <div className={cx('flex items-start justify-between gap-4', className)}>
      <div className="min-w-0 text-left">
        {label && <p id={labelId} className="text-sm font-medium text-gray-900 dark:text-white">{label}</p>}
        {description && <p id={descriptionId} className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{description}</p>}
      </div>
      {control}
    </div>
  );
};

export default Toggle;
